import { mapValues } from 'lodash';
import { DragAndDropPinLayoutTemplate, DragAndDropTeacherPin } from '../../models';
import { PinCreationParams } from './pin-helper-types';

const layoutsWithLinkedPinComponents = ['QUAD_DROP_ZONE_TEXT', 'QUAD_DROP_ZONE_IMAGE'];

const dragItemsPartKeys = [
  'IMAGE1',
  'IMAGE2',
  'IMAGE3',
  'IMAGE4',
  'TEXT_ITEM_1',
  'TEXT_ITEM_2',
  'TEXT_ITEM_3',
  'TEXT_ITEM_4',
];

export const newDragAndDropPin = (layout: DragAndDropPinLayoutTemplate): PinCreationParams<DragAndDropTeacherPin> => {
  const basePin: PinCreationParams<DragAndDropTeacherPin> = {
    type: 'DRAG_AND_DROP',
    settings: {
      layout: layout.key,
      backgroundColor: layout.backgroundColor,
      backgroundImage: layout.backgroundImage,
      layoutParts: mapValues(layout.layoutParts, (comp) => comp?.id),
      linkedPinComponents: {},
    },
    teacherSettings: {
      correctAnswers: {},
    },
    pinComponents: [...Object.values(layout.layoutParts), ...layout.pinComponents],
  };

  if ('backgroundTransparency' in layout && layout.backgroundTransparency !== undefined) {
    basePin.settings.backgroundTransparency = layout.backgroundTransparency;
  }

  if (layoutsWithLinkedPinComponents.includes(layout.key)) {
    Object.entries(layout.layoutParts).forEach(([key, componentPart]) => {
      if (dragItemsPartKeys.includes(key)) {
        basePin.settings.linkedPinComponents[componentPart.id] = [];
      }
    });
  }

  return basePin;
};

export type CorrectDragAndDropPinAnswers = { [key: string]: string[] };

export function cleanAndGetCorrectDragAndDropPinAnswers(pin: DragAndDropTeacherPin): CorrectDragAndDropPinAnswers {
  const linkedPinComponents = pin.settings.linkedPinComponents;
  pin.settings.linkedPinComponents = {};
  const newLinkedPinComponents = Object.fromEntries(Object.entries(linkedPinComponents).map(([key]) => [key, []]));
  pin.settings.linkedPinComponents = newLinkedPinComponents;
  return linkedPinComponents;
}

export function transformDragAndDropForAssignment(pin: DragAndDropTeacherPin): DragAndDropTeacherPin {
  const correctAnswers = cleanAndGetCorrectDragAndDropPinAnswers(pin);

  return {
    ...pin,
    teacherSettings: {
      ...pin.teacherSettings,
      correctAnswers,
    },
  };
}
